export interface Task {
  clientDecision?: { disposition: 'requested' | 'deferred' | 'undecided'; priority: 'high' | 'medium' | 'low'; authorId: string; authorName: string };
  workApproval?: { status: 'pending' | 'approved' | 'declined' | 'not-requested'; authorName?: string };
  id: string;
  clientId: string;
  projectId?: string | null;
  title: string;
  description?: string;
  status: TaskStatus;
  priority: TaskPriority;
  /** Absent or `null` in Firestore when no due date is set. */
  dueDate?: Date | null;
  /** Optional estimate in hours for planning/capacity. */
  estimatedHours?: number | null;
  /** Optional project-specific version string (e.g., 1, 1.2, 0.15.10). */
  version?: string | null;
  /** Product surface within the project (a project `platforms` id). */
  platform?: string | null;
  /** The client's suggested order, set from ChatGPT. Never drives `priority`. */
  clientPriority?: { rank: number; byName?: string | null; note?: string | null } | null;
  /** The client's verdict on a task we marked done. */
  clientAcceptance?: {
    status: 'accepted' | 'changes_requested';
    byName?: string | null;
    note?: string | null;
  } | null;
  /** Optional project-specific labels (e.g., bug, feature, enhancement). */
  labels?: string[];
  assignedTo?: string[];
  jira?: {
    issueId?: string;
    issueKey?: string;
    issueUrl?: string;
  };
  github?: {
    repoId?: number;
    issueId?: number;
    issueNumber?: number;
    issueTitle?: string;
    issueUrl?: string;
    branchName?: string;
    branchUrl?: string;
  };
  createdBy?: string;
  createdAt: Date;
  updatedAt: Date;
}

export enum TaskStatus {
  TODO = 'todo',
  IN_PROGRESS = 'in-progress',
  IN_REVIEW = 'in-review',
  BLOCKED = 'blocked',
  DONE = 'done',
}

export enum TaskPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent',
}
